var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress__container",class:{
    'progress__container--full': _vm.hiddenLabel,
    'progress__container--block': _vm.labelInBottom,
  }},[_c('div',{staticClass:"progress",class:{
      'progress--thin': _vm.isThin,
      'progress--rounded': _vm.isRounded,
      'progress--incorret-progress': _vm.isIncorretProgress,
    }},[_c('span',{staticClass:"progress__content",class:{
        'progress--rounded': _vm.isRounded,
      },style:({ width: `${_vm.progress}%` })})]),(!_vm.hiddenLabel)?_c('span',{staticClass:"progress__right",class:{
      'progress-span-block': _vm.labelInBottom,
      'progress-span-circule-block': _vm.labelInBottom && _vm.completed,
    }},[(_vm.completed)?_c('Icon',{staticClass:"progress__icon",attrs:{"name":"check","size":22}}):_c('small',{staticClass:"progress__label subtitle-2",class:{
        'progress__label--blackboard': _vm.progress,
        'progress__label--capitalize': _vm.completed,
        'progress__label--block': _vm.labelInBottom,
        'progress__label--black': _vm.labelIsBlack,
      }},[_vm._v(" "+_vm._s(_vm.progress)+"% ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }